import React, { useCallback, useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { ObjetoContrato } from './objeto';
import { ParcelaContrato } from './parcela';
import { SubAbasContratos, SubAbasContratosNovo } from './subabasContratos';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import { CustomSwal } from '../../../../components/CustomFeedback/CustomSwal';
import CustomRow from '../../../../components/CustomRow';
import FiscalContratoComponente from '../../../../components/FiscalContrato';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import ParteEnvolvidaComponente from '../../../../components/ParteEnvolvida';
import ResponsavelAquisicaoComponente from '../../../../components/ResponsavelAquisicao';
import SubAbas from '../../../../components/SubAbas';
import TramitacaoComponente from '../../../../components/Tramitacao';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../modules/contexts/Select/useSelect';
import { getTipoEnvolvimentoOptions } from '../../../../modules/types/TipoEnvolvimentoEnum';
import { EnumOption } from '../../../../modules/types/types';
import {
  getContrato,
  handleCreateContrato,
  handleDeleteContrato,
  handleUpdateContrato,
} from '../../../../services/contratos/contratosService';
import { getAllFornecedoresSimplificado } from '../../../../services/fornecedoresDAF/fornecedorService';
import { isHttpError } from '../../../../services/httpClient';
import { getAllDenominacoesGenericas } from '../../../../services/produtosDAF/denominacoesGenericasService';
import {
  getAllKitDeProduto,
  getProdutosDoKit,
} from '../../../../services/produtosDAF/kitProdutoService';
import { getProdutosByDenominacaoGenericaId } from '../../../../services/produtosDAF/produtosDafService';
import {
  formataNomeMeioSiglas,
  formatDateSimp,
  sanitizarForm,
} from '../../../../utils/functions';
import {
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../utils/swal';
import { Fornecedor } from '../../Fornecedores/types';

interface IContrato {
  id: number | string;

  //fks
  usuarioId: number | string;
  proaqId: number;
  proaq?: any; //TODO: criar interface Proaq
  arpId?: number;
  arp?: any; //TODO: criar interface ARP
  fornecedorId: number;
  cnpj: string;
  fornecedor?: Fornecedor;
  denominacaoGenericaId: number;
  denominacaoGenerica?: any;
  kitProdutosDAFId: number;
  kitProdutosDAF?: any;

  //enums
  tipoContrato: number;
  statusContrato: number;
  leiLicitacao: number;
  componenteAf: number;
  tipoEnvolvimento: number;
  modalidade: number;
  submodalidade: number;

  //dados
  dataPublicacao: string;
  dataVigencia: string;
  prazoVigencia: string;
  numeroSeiContrato: string;
  numeroDocumentoSEI: string;
  numeroContrato: string;

  observacoes: string;
}

//const entity = ENTITY.ENTITY_Contratos;

export default function ContratosFicha() {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;
  const userComponenteAFLabel =
    user?.vinculo?.[0]?.nomeInstituicao ?? 'Não informado';
  const userComponenteAF = Number(user.vinculo[0].numeroComponenteAF);

  const navigate = useNavigate();
  const location = useLocation();
  const locationData = location.state;
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  // gets
  const { getSelectDominioPai } = useSelect();
  const statusContratoOptions = getSelectDominioPai(52);
  const tipoContratoOptions = getSelectDominioPai(79);
  const leiLicitacaoOptions = getSelectDominioPai(65);
  const componenteAfOptions = getSelectDominioPai(1);
  const modalidadeAquisicaoOptions = getSelectDominioPai(133);
  const submodalidadeAquisicaoOptions = getSelectDominioPai(139);

  //States
  const [formContrato, setFormContrato] = useState<IContrato>({
    usuarioId: userID,
    id: 0,

    //fks
    fornecedorId: locationData ? locationData.formNewContrato.fornecedorId : 0,
    cnpj: locationData ? locationData.formNewContrato.cnpj : '',
    proaqId: locationData ? locationData.formNewContrato.proaqId : 0,
    proaq: locationData ? locationData.formNewContrato.proaq : null,
    arpId: locationData ? locationData.formNewContrato.arpId : 0,
    arp: locationData ? locationData.formNewContrato.arp : null,
    denominacaoGenericaId:
      locationData?.formNewContrato?.proaq?.denominacaoGenerica?.id ?? 0,
    denominacaoGenerica: locationData
      ? locationData.formNewContrato.denominacaoGenerica
      : null,
    kitProdutosDAFId:
      locationData?.formNewContrato?.proaq?.KitProdutoDAF?.id ?? 0,
    kitProdutosDAF: locationData
      ? locationData.formNewContrato.kitProdutosDAF
      : null,

    //enums
    tipoContrato: 0,
    statusContrato: 0,
    leiLicitacao: 0,
    componenteAf: locationData ? userComponenteAF : 0,
    tipoEnvolvimento: locationData
      ? locationData.formNewContrato.tipoEnvolvimento
      : 0,

    //dados
    dataPublicacao: '',
    dataVigencia: '',
    prazoVigencia: '',
    numeroSeiContrato: locationData
      ? locationData.formNewContrato.proaq?.numeroSeiProaq
      : '',
    numeroDocumentoSEI: '',
    numeroContrato: '',

    //dados de relacionamentos
    modalidade: locationData
      ? locationData.formNewContrato.proaq.modalidade
      : 0,
    submodalidade: locationData
      ? locationData.formNewContrato.proaq.submodalidade
      : 0,

    //obs
    observacoes: '',
  });
  const [fornecedoresData, setFornecedoresData] = useState<any[]>([]);
  const [denominacaoGenericaData, setdenominacaoGenericaData] = useState<any[]>(
    [],
  );

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [refreshKey, setRefreshKey] = useState(0);

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getContrato(id);
      setLogData(registroData);

      let dataFimVigencia: Date | null = null;
      let prazoVigencia = '';

      if (registroData.dataPublicacao) {
        dataFimVigencia = new Date(registroData.dataPublicacao);
        dataFimVigencia.setDate(dataFimVigencia.getDate() + 365);

        const hoje = new Date();
        const dias = Math.ceil(
          (dataFimVigencia.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24),
        );
        prazoVigencia = dias.toString();
      }

      const dataPublicacao = registroData.dataPublicacao
        ? new Date(registroData.dataPublicacao).toISOString().split('T')[0]
        : '';

      const dataVigencia = registroData.dataVigencia
        ? new Date(registroData.dataVigencia).toISOString().split('T')[0]
        : '';

      setFormContrato({
        usuarioId: userID,
        id: registroData.id,

        //fks
        proaqId: registroData.proaq?.id ?? 0,
        arpId: registroData.arp?.id ?? 0,
        fornecedorId: registroData.fornecedor?.id ?? 0,
        cnpj: registroData.fornecedor?.cnpj ?? '',
        denominacaoGenericaId: registroData.denominacaoGenerica?.id ?? 0,
        denominacaoGenerica: registroData.denominacaoGenerica ?? null,
        kitProdutosDAFId: registroData.kitProdutoDAF?.id ?? 0,
        kitProdutosDAF: registroData.kitProdutoDAF ?? null,

        //enums
        tipoContrato: registroData.tipoContrato,
        statusContrato: registroData.statusContrato,
        leiLicitacao: registroData.leiLicitacao,
        componenteAf: registroData.componenteAf,
        tipoEnvolvimento: registroData.tipoEnvolvimento,

        //dados
        dataPublicacao: dataPublicacao,
        dataVigencia: dataVigencia,
        prazoVigencia: prazoVigencia,
        numeroSeiContrato: registroData.numeroSeiContrato,
        numeroDocumentoSEI: registroData.numeroDocumentoSEI,
        numeroContrato: registroData.numeroContrato,

        modalidade: registroData.proaq.modalidade,
        submodalidade: registroData.proaq.submodalidade,
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };
    //Subabas
    subAbas = SubAbasContratos(fichaID);
  } else {
    subAbas = SubAbasContratosNovo;
  }

  const fetchFornecedores = async () => {
    try {
      const fornecedoresData = await getAllFornecedoresSimplificado();
      setFornecedoresData(fornecedoresData);
    } catch (error: any) {
      if (isHttpError(error)) {
        console.error(error.response?.data.message);
      }
    }
  };

  useEffect(() => {
    fetchFornecedores();
  }, []);

  useEffect(() => {
    if (fichaID !== 'undefined') {
      if (fornecedoresData) {
        const cnpj =
          fornecedoresData.find(
            (fornecedor) => fornecedor.id === formContrato.fornecedorId,
          )?.cnpj ?? '';
        setFormContrato({ ...formContrato, cnpj: cnpj });
      }
    }
  }, [formContrato.fornecedorId]);

  const fornecedoresOptions = [
    { value: 0, label: 'Não informado' },
    ...fornecedoresData.map((item) => ({
      value: item.id,
      label: item.razaoSocial,
    })),
  ];

  const denominacoesGenericasOptions = [
    { value: 0, label: 'Não informado' },
    ...denominacaoGenericaData.map((item) => ({
      value: item.id,
      label: item.denominacaoGenerica,
    })),
  ];

  useEffect(() => {
    if (formContrato.denominacaoGenericaId || formContrato.kitProdutosDAFId) {
      fetchOptions();
    }
  }, [formContrato]);

  const [kitProdutoData, setkitProdutoData] = useState<any[]>([]);

  const kitProdutoOptions = [
    { value: 0, label: 'Não informado' },
    ...kitProdutoData.map((item) => ({
      value: item.id,
      label: item.nomeKit,
    })),
  ];

  const [produtosDAFOptions, setProdutosDAFOptions] = useState<EnumOption[]>([
    { value: '0', label: 'Não informado' },
  ]);
  const fetchOptions = async () => {
    try {
      const denominacoesGenericasData = await getAllDenominacoesGenericas();
      setdenominacaoGenericaData(denominacoesGenericasData);

      const kitProdutoData = await getAllKitDeProduto();
      setkitProdutoData(kitProdutoData);

      let produtosData = [];

      if (formContrato.denominacaoGenericaId) {
        produtosData = await getProdutosByDenominacaoGenericaId(
          formContrato.denominacaoGenericaId?.toString(),
        );
      } else if (formContrato.kitProdutosDAFId) {
        produtosData = await getProdutosDoKit(
          formContrato.kitProdutosDAFId.toString(),
        );
      }

      // Converter os dados para o formato correto
      const newOptions = produtosData.map((item: any) => ({
        value: item.produtoDAF?.id || item.id, // Ajuste para diferentes estruturas
        label: item.produtoDAF?.produtoFarmaceutico || item.produtoFarmaceutico,
      }));

      // Remover duplicatas usando um Set e depois convertendo de volta para array
      const uniqueOptions = Array.from(
        new Map([...newOptions].map((item) => [item.value, item])).values(),
      );

      setProdutosDAFOptions([
        { value: '0', label: 'Não informado' },
        ...uniqueOptions,
      ]);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
    }
  };

  const [isDataPublicacaoReadOnly, setIsDataPublicacaoReadOnly] =
    useState(false);
  useEffect(() => {
    if (formContrato.statusContrato > 53) {
      setIsDataPublicacaoReadOnly(false);
    } else {
      setIsDataPublicacaoReadOnly(true);
      setFormContrato((prev) => ({
        ...prev,
        dataPublicacao: '',
        dataVigencia: '',
        prazoVigencia: '',
      }));
    }
  }, [formContrato.statusContrato]);

  useEffect(() => {
    const { dataPublicacao, dataVigencia } = formContrato;

    if (dataPublicacao && dataVigencia) {
      const dtPub = new Date(dataPublicacao);
      const dtVig = new Date(dataVigencia);

      if (dtVig < dtPub) {
        setFormContrato((prev) => ({
          ...prev,
          dataVigencia: '',
        }));
        swalAttention(
          `A data de <b>vigência</b> ${formatDateSimp(dataVigencia)} <b><span style="color:red">não pode ser anterior</span></b> à data de <b>início</b> ${formatDateSimp(dataPublicacao)}.`,
        );
      }
    }
  }, [formContrato.dataPublicacao, formContrato.dataVigencia]);

  const [isDataRequired, setIsDataRequired] = useState(false);
  useEffect(() => {
    if (Number(formContrato.statusContrato) > 53) {
      setIsDataRequired(true);
    } else {
      setIsDataRequired(false);
    }
  }, [formContrato.statusContrato]);

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    if (name === 'dataPublicacao') {
      const novaDataVigencia = new Date(value);
      novaDataVigencia.setDate(novaDataVigencia.getDate() + 365);

      // Calcula o prazo como hoje - dataVigencia
      const hoje = new Date();
      const diferencaEmDias = Math.ceil(
        (novaDataVigencia.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24),
      );

      setFormContrato((prevState) => ({
        ...prevState,
        dataPublicacao: value,
        dataVigencia: novaDataVigencia.toISOString().split('T')[0], // Formato YYYY-MM-DD
        prazoVigencia: diferencaEmDias > 0 ? diferencaEmDias.toString() : '', // Define 0 se a diferença for negativa
      }));
    } else {
      setFormContrato((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const forceRefresh = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  const handleObjetoChange = useCallback(() => {
    forceRefresh();
  }, [forceRefresh]);

  const handleParcelaChange = useCallback(() => {
    forceRefresh();
  }, [forceRefresh]);

  const validateForm = (form: IContrato) => {
    const errors: string[] = [];

    if (!form.proaqId) {
      errors.push('<b>Processo Aquisitivo</b> é obrigatório.');
    }

    if (!form.fornecedorId) {
      errors.push('<b>Fornecedor</b> é obrigatório.');
    }

    if (!form.tipoEnvolvimento) {
      errors.push('<b>Papel do Fornecedor</b> é obrigatório.');
    }

    if (form.statusContrato == 0) {
      errors.push('<b>Status do Contrato</b> é obrigatório.');
    }

    if (!form.tipoContrato) {
      errors.push('<b>Tipo do Contrato</b> é obrigatório.');
    }

    if (!form.leiLicitacao) {
      errors.push('<b>Lei de Licitação</b> é obrigatória.');
    }

    if (!form.numeroContrato) {
      errors.push('<b>Nº do Contrato</b> é obrigatória.');
    }

    if ([54, 55].includes(form.statusContrato)) {
      if (!form.dataPublicacao) {
        errors.push('<b>Data de Publicação</b> é obrigatória.');
      }
      if (!form.dataVigencia) {
        errors.push('<b>Data de Vigência</b> é obrigatória.');
      }
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const formatForm = (form: IContrato) => {
    const formAjustado = {
      ...form,
      tipoEnvolvimento: Number(form.tipoEnvolvimento),
      fornecedorId: Number(form.fornecedorId),
      statusContrato: Number(Number(form.statusContrato)),
      leiLicitacao: Number(form.leiLicitacao),
      tipoContrato: Number(Number(form.tipoContrato)),
    };

    return formAjustado;
  };

  const handleCreate = async () => {
    if (
      ['Gabinete', 'Coordenação de Fiscalização de Contratos'].includes(
        userComponenteAFLabel,
      )
    ) {
      CustomSwal.show({
        type: 'warning',
        title: 'Atenção',
        html: 'Usuários vinculados ao Gabinete ou à Coordenação de Fiscalização de Contratos não podem criar ACTs.',
        showConfirmButton: true,
      });
      return;
    }
    try {
      if (!validateForm(formContrato)) throw new Error('Formulário inválido.');
      const formAjustado = formatForm(formContrato);
      const formToSend = sanitizarForm(formAjustado);

      const response = await handleCreateContrato(formToSend);

      swalSave();
      setTimeout(
        () =>
          navigate(`/daf/proaq/contratos/${response.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(formContrato)) throw new Error('Formulário inválido.');
      const formAjustado = formatForm(formContrato);
      const formToSend = sanitizarForm(formAjustado);

      const response = await handleUpdateContrato(formToSend);

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      if (formContrato.id) {
        await handleDeleteContrato(formContrato.id);
      } else return;

      swalDeleteConfirm();
      navigate('/daf/proaq/contratos');
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao excluir registro', error);
    }
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/contratos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          {fichaID !== 'undefined' && <Log {...logs} />}

          {/* Identificação do Contrato */}
          <BoxConteudo boxTitulo="Identificação do Contrato">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="200px">
                <SelectInput
                  name="statusContrato"
                  options={statusContratoOptions}
                  label="Status"
                  value={formContrato.statusContrato}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="componenteAf"
                  options={componenteAfOptions}
                  label="Componente AF"
                  value={formContrato.componenteAf}
                  onChange={handleChange}
                  disabled
                />
              </CustomCol>

              <CustomCol width="200px">
                <Input
                  id="modAquisicao"
                  name="modAquisicao"
                  label="Modalidade de Aquisição"
                  value={
                    (modalidadeAquisicaoOptions.find(
                      (option) => option.value === formContrato.modalidade,
                    )?.label ?? '') +
                      ' ' +
                      (submodalidadeAquisicaoOptions.find(
                        (option) => option.value === formContrato.submodalidade,
                      )?.label ?? '') || 'Não se aplica'
                  }
                  onChange={handleChange}
                  onClick={() => {
                    if (formContrato.arpId) {
                      const url = `#/daf/proaq/arps/${formContrato.arpId}/dadosgerais`;
                      window.open(url, '_blank');
                    } else {
                      const url = `#/daf/proaq/processos/${formContrato.proaqId}/dadosgerais`;
                      window.open(url, '_blank');
                    }
                  }}
                  style={{
                    color: 'blue',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  readonly
                />
              </CustomCol>

              <CustomCol>
                <Input
                  name="numeroContrato"
                  label="Nº do Contrato"
                  value={formContrato.numeroContrato}
                  id="numeroContrato"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="150px">
                <SelectInput
                  name="tipoContrato"
                  options={tipoContratoOptions}
                  label="Tipo de Contrato"
                  value={formContrato.tipoContrato}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol
                width="180px"
                helpText="Data inicial da vigência do Contrato"
              >
                <Input
                  name="dataPublicacao"
                  label="Início da Vigência"
                  value={formContrato.dataPublicacao}
                  id="dataPublicacao"
                  onChange={handleChange}
                  type="date"
                  readonly={isDataPublicacaoReadOnly}
                  required={isDataRequired}
                />
              </CustomCol>
              <CustomCol
                width="180px"
                helpText="Data final da vigência do Contrato"
              >
                <Input
                  name="dataVigencia"
                  label="Término da Vigência"
                  value={formContrato.dataVigencia}
                  id="dataVigencia"
                  onChange={handleChange}
                  type="date"
                  readonly={isDataPublicacaoReadOnly}
                  required={isDataRequired}
                />
              </CustomCol>
              <CustomCol helpText="Prazo da vigência em dias" width="100px">
                <Input
                  name="prazoVigencia"
                  label="Prazo"
                  value={formContrato.prazoVigencia}
                  id="prazoArp"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
            </CustomRow>

            <CustomRow>
              <CustomCol width="200px">
                <SelectInput
                  name="leiLicitacao"
                  options={leiLicitacaoOptions}
                  label="Lei de Licitação"
                  value={formContrato.leiLicitacao}
                  required
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  id="numeroSeiContrato"
                  name="numeroSeiContrato"
                  label="Nº Processo SEI"
                  value={formContrato.numeroSeiContrato}
                  onChange={handleChange}
                  mascara="99999.999999/9999-99"
                  disabled
                  onClick={() => {
                    if (formContrato.proaqId) {
                      const url = `#/daf/proaq/processos/${formContrato.proaqId}/dadosgerais`;
                      window.open(url, '_blank');
                    }
                  }}
                  style={{
                    color: 'blue',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                />
              </CustomCol>
              <CustomCol width="150px">
                <Input
                  id="numeroDocumentoSEI"
                  name="numeroDocumentoSEI"
                  label="Documento SEI"
                  value={formContrato.numeroDocumentoSEI}
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>

              {/* <CustomCol width="300px">
                <Input
                  name="valorTotal"
                  label="Valor Total R$"
                  value={formContrato.proaq?.valorTotal ?? 'Valor aqui!!'}
                  id="valorTotal"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  disabled
                />
              </CustomCol> */}

              {formContrato.denominacaoGenericaId &&
              formContrato.denominacaoGenericaId !== 0 ? (
                <CustomCol>
                  <SelectInput
                    name="denominacaoGenericaId"
                    options={denominacoesGenericasOptions}
                    label="Denominação Genérica"
                    value={formContrato.denominacaoGenericaId}
                    onChange={handleChange}
                    disabled={true}
                    onClick={() => {
                      if (formContrato.denominacaoGenericaId) {
                        const url = `#/daf/produtosdaf/denominacoes/${formContrato.denominacaoGenericaId}/dadosgerais`;
                        window.open(url, '_blank');
                      }
                    }}
                    style={{
                      color: 'blue',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                  />
                </CustomCol>
              ) : formContrato.kitProdutosDAFId &&
                formContrato.kitProdutosDAFId !== 0 ? (
                <CustomCol>
                  <SelectInput
                    name="kitProdutosDAFId"
                    options={kitProdutoOptions}
                    label="Kit de Produtos DAF"
                    value={formContrato.kitProdutosDAFId}
                    onChange={handleChange}
                    disabled={true}
                    onClick={() => {
                      if (formContrato.kitProdutosDAFId) {
                        const url = `#/daf/produtosdaf/kits/${formContrato.kitProdutosDAFId}/dadosgerais`;
                        window.open(url, '_blank');
                      }
                    }}
                    style={{
                      color: 'blue',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                  />
                </CustomCol>
              ) : locationData?.formNewContrato.denominacaoGenericaId ? (
                <CustomCol>
                  <SelectInput
                    name="denominacaoGenericaId"
                    options={denominacoesGenericasOptions}
                    label="Denominação Genérica"
                    value={formContrato.denominacaoGenericaId}
                    onChange={handleChange}
                    disabled={true}
                  />
                </CustomCol>
              ) : (
                <CustomCol>
                  <SelectInput
                    name="kitProdutosDAFId"
                    options={kitProdutoOptions}
                    label="Kit de Produtos DAF"
                    value={formContrato.kitProdutosDAFId}
                    onChange={handleChange}
                    disabled={true}
                  />
                </CustomCol>
              )}
            </CustomRow>

            {/* Fornecedor */}
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  id="cnpj"
                  name="cnpj"
                  label="CNPJ"
                  value={formContrato.cnpj}
                  onChange={handleChange}
                  disabled
                />
              </CustomCol>
              <CustomCol>
                <SelectInput
                  name="fornecedorId"
                  options={fornecedoresOptions}
                  label="Fornecedor"
                  value={formContrato.fornecedorId}
                  onChange={handleChange}
                  disabled
                  onClick={() => {
                    if (formContrato.fornecedorId) {
                      const url = `#/daf/fornecedores/fornecedores/${formContrato.fornecedorId}/dadosgerais`;
                      window.open(url, '_blank');
                    }
                  }}
                  style={{
                    color: 'blue',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                />
              </CustomCol>
              <CustomCol width="215px">
                <SelectInput
                  name="papelParte"
                  options={getTipoEnvolvimentoOptions()}
                  label="Papel do Fornecedor"
                  value={formContrato.tipoEnvolvimento}
                  onChange={handleChange}
                  disabled
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {fichaID !== 'undefined' && (
            <>
              <ObjetoContrato
                fichaID={fichaID}
                userID={userID}
                contratoData={formContrato}
                onDataChange={handleObjetoChange}
                key={`objetoContrato-${refreshKey}`}
              />

              <ParcelaContrato
                fichaID={fichaID}
                userID={userID}
                contratoData={formContrato}
                onDataChange={handleParcelaChange}
                key={`parcelaContrato-${refreshKey}`}
              />

              {/* Seção Partes Envolvidas */}
              <ParteEnvolvidaComponente tab="contrato" id_tab={fichaID} />

              {/* Seção Fiscal do Contrato */}
              <FiscalContratoComponente tab="contrato" id_tab={fichaID} />

              {/* Seção Responsáveis da Aquisição */}
              <ResponsavelAquisicaoComponente tab="contrato" id_tab={fichaID} />

              {/* Seção Termo Aditivo */}
              {/* <TermoAditivoComponente tab="contrato" id_tab={fichaID} /> */}

              {/* Seção Tramitação SEI */}
              <TramitacaoComponente tab="contrato" id_tab={fichaID} />
            </>
          )}

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formContrato.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
